import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useCallback } from 'react';
import { Modal } from 'react-bootstrap4-modal';
import useModal from './useModal';
const AlertContext = createContext({
    alert: () => {
        /* empty default function */
    },
});
export function AlertProvider({ children, okText }) {
    var _a, _b;
    const modal = useModal();
    const alert = useCallback((message) => modal.open({ message }), [modal.open]);
    return (_jsxs(AlertContext.Provider, Object.assign({ value: { alert } }, { children: [children, _jsxs(Modal, Object.assign({ visible: modal.visible }, { children: [_jsx("div", Object.assign({ className: "modal-body" }, { children: (_b = (_a = modal.state) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : _jsx("div", {}) })), _jsx("div", Object.assign({ className: "modal-footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-primary", onClick: modal.close }, { children: okText })) }))] }))] })));
}
export function useAlert() {
    const { alert } = useContext(AlertContext);
    return alert;
}
//# sourceMappingURL=Alert.js.map